<template>
    <div class="card">
        <img v-if="img" class="card-img-top" :src="img" :alt="title">
        <div class="card-body">
            <h4 class="card-title" v-html="title"></h4>
            <slot></slot>
        </div>
        <div class="card-footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        img: {type: String, required: false},
        title: {type: String, default: ''}
    }
}
</script>

<style lang="scss">
    .card {
        background-color: #fff;
        border: none;
        border-radius: .625rem !important;
        box-shadow: 0 .46875rem 2.1875rem rgba(90,97,105,.1),0 .9375rem 1.40625rem rgba(90,97,105,.1),0 .25rem .53125rem rgba(90,97,105,.12),0 .125rem .1875rem rgba(90,97,105,.1);
        border-bottom: .5rem solid var(--primary) !important;


        .btn {
            font-weight: 500;
            text-transform: uppercase;
        }

        &.inverted {
            background: #f9fafc;
        }
    }
</style>
